// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"IW-z","inlineTitle":"JW-z","sponsoredAdsWrapper":"KW-z","marketplaceRecosWrapper":"LW-z"};